﻿import { all } from "promise";

export default class CashierOrderSearch {
  constructor(props) {
      this.props = props;
    this.el = $('#CashierOrderSearch-Component');
    if (!this.el.length) { return false; }


    $.datepicker.regional['sv'] = {
      closeText: 'Stäng', // set a close button text
      currentText: 'Idag', // set today text
      monthNames: ['Januari', 'Februari', 'Mars', 'April', 'Maj', 'Juni', 'Juli', 'Augusti', 'September', 'Oktober', 'November', 'December'], // set month names
      monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'], // set short month names
      dayNames: ['Söndag', 'Måndag', 'Tisdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lördag'], // set days names
      dayNamesShort: ['Sön', 'Mån', 'Tis', 'Ons', 'Tor', 'Fre', 'Lör'], // set short day names
      dayNamesMin: ['Sö','Må', 'Ti', 'On', 'To', 'Fr', 'Lö'], // set more short days names
      dateFormat: 'yy-mm-dd', // set format date
      firstDay: 1
    };

    $.datepicker.setDefaults($.datepicker.regional['sv']);

    this.btnExpand = this.el.find('#btnExpand');
    this.searchOrderId = this.el.find('#searchOrderId');
    this.searchOrderDateFrom = this.el.find('#searchOrderDateFrom');
    this.searchOrderDateFrom.datepicker({ dateFormat: 'yy-mm-dd' });
    this.searchOrderDateTo = this.el.find('#searchOrderDateTo');
    this.searchOrderDateTo.datepicker();

    this.chkListFilter_showAll = this.el.find('#chkListFilter_showAll');

    // Extended searchfileds
    this.searchEventName = this.el.find('#searchEventName');
    this.searchOrderSeat = this.el.find('#searchOrderSeat');
    this.searchOrderPaymentType = this.el.find('#searchOrderPaymentType');
    this.searchOrderType = this.el.find('#searchOrderType');
    this.searchIncludeRefunds = this.el.find('#searchIncludeRefunds');
    this.searchIncludeReservations = this.el.find('#searchIncludeReservations');

    this.PointOfSales = this.el.find(".poslist input");

    this.searchCustomerFirstname = this.el.find('#searchCustomerFirstname');
    this.searchCustomerLastname = this.el.find('#searchCustomerLastname');
    this.searchCustomerEmail = this.el.find('#searchCustomerEmail');
    this.searchCustomerPhone = this.el.find('#searchCustomerPhone');
    this.searchCustomerCompany = this.el.find('#searchCustomerCompany');

    this.searchCustomerAdress = this.el.find('#searchCustomerAdress');
    this.searchCustomerZipCode = this.el.find('#searchCustomerZipCode');
    this.searchCustomerCity = this.el.find('#searchCustomerCity');
    this.searchCustomerPin = this.el.find('#searchCustomerPin');
    this.searchCustom = this.el.find('#searchCustom');

    this.cntSearchHits = this.el.find('#cntSearchHits');
    this.resultTable = this.el.find('#result_table');
    this.btnSearch_submit = this.el.find('#btnSearch_submit');

    this.btnEditCustomer = this.el.find('.orderview');
    this.btnYabiePrint = this.el.find('.orderview');
    this.searchResultList = this.el.find('#searchResultList');
    this.btnDownloadResult = this.el.find('#btnDownloadResult');
    this._btnShowOrder = this._btnShowOrder.bind(this);


    // MODAL
    this.customerFirstname = this.el.find('#customer_firstname');
    this.customerLastname = this.el.find('#customer_lastname');
    this.customerEmail = this.el.find('#customer_email');
    this.customerPhone = this.el.find('#customer_phone');
    this.customerAddress = this.el.find('#customer_address');
    this.customerAddress2 = this.el.find('#customer_address2');
    this.customerZipCode = this.el.find('#customer_zipcode');
    this.customerCity = this.el.find('#customer_city');
    this.customerCountry = this.el.find('#customer_country');
    this.customerPhone2 = this.el.find('#customer_phone2');
    this.customerOrderId = this.el.find('#customer_orderid');
    this.customerUpdateOnOrder = this.el.find('#customer_updateonorder');
    this.customerupdateAllOrders = this.el.find('#customer_updateAllOrders');
    this._disableOrderbuttons = this._disableOrderbuttons.bind(this);

    this.checkboxChecked = this.el.find('.orderview');
    this.checkboxChecked.on('click', this._disableOrderbuttons);

      this.btnModalMsg = this.el.find('#CashierCheckout-Component-editcustomer-modal-messageblock');
      this.btnModalMsgSuccess = this.el.find('#CashierCheckout-Component-editcustomer-modal-messageblock-success');
      this.btnModalLoading = this.el.find('#CashierCheckout-Component-editcustomer-modal-messageblock-loading');
    this.modalTitle = this.el.find('#CashierCheckout-Component-modal-title');
    this.modalAddCustomer = this.el.find('#CashierCheckout-Component-addcustomer-modal');
    this.customerEditResponseMessageDiv = this.el.find('#customer-edit-response-message');

    this.btnModalClose = this.el.find('.close');
    this.btnModalCancel = this.el.find('#CashierCheckout-Component-addcustomer-modal-cancel');
    this.btnModalEditSubmit = this.el.find('#CashierCheckout-Component-editcustomer-modal-submit');

    this._btnCustomerModalCancel = this._btnCustomerModalCancel.bind(this);
    this._btnCustomerModalEditSubmit = this._btnCustomerModalEditSubmit.bind(this);
    this._searchSubmit = this._searchSubmit.bind(this);
    this._editCustomer = this._editCustomer.bind(this);
    this._yabiePrint = this._yabiePrint.bind(this);
    this._getReservationOrder = this._getReservationOrder.bind(this);
    this.btnEditCustomer.on('click', this._editCustomer);
    this.btnModalCancel.on('click', this._btnCustomerModalCancel);
    this.btnModalClose.on('click', this._btnCustomerModalCancel);
    this.btnModalEditSubmit.on('click', this._btnCustomerModalEditSubmit);
    this.btnYabiePrint.on('click', this._yabiePrint);
    this.btnSearch_submit.on('click', this._searchSubmit);
    this.searchResultList.on('click', '.btnShowOrder', this._btnShowOrder);
    // INIT
    this.openOnInit = this.el.find('.open-on-init');
    if (this.openOnInit != null) {
      this.openOnInit.click();
    }
  }

  _back() {
    this.finalForm.hide();
    this.selectCustomerForm.fadeIn();
  }




  _searchSubmit(hidden) {

    var _this = this;
    var POSs = [];
    for (var i = 0; i < this.PointOfSales.length; i++) {
      if (this.PointOfSales[i].checked) {
        POSs.push(this.PointOfSales[i].id);
      }
    }
    var searchParamsModel = {
          SoldBy: _this.chkListFilter_showAll.prop('checked'),
          OrderNumber: _this.searchOrderId.val(),
          OrderDateFrom: _this.searchOrderDateFrom.val(),
          OrderDateTo: _this.searchOrderDateTo.val(),

          EventName: _this.searchEventName.val(),
          POSs: POSs,
          Seat: _this.searchOrderSeat.val(),
          PaymentWay: _this.searchOrderPaymentType.val(),
          OrderType: _this.searchOrderType.val(),
          IncludeRefunds: _this.searchIncludeRefunds.prop('checked'),
          IncludeReservations: _this.searchIncludeReservations.prop('checked'),

          CustomerFirstName: _this.searchCustomerFirstname.val(),
          CustomerLastName: _this.searchCustomerLastname.val(),
          CustomerZipCode: _this.searchCustomerZipCode.val(),
          CustomerEmail: _this.searchCustomerEmail.val(),
          CustomerAddress: _this.searchCustomerAdress.val(),
          CustomerCity: _this.searchCustomerCity.val(),
          CustomerPhone: _this.searchCustomerPhone.val(),
          Pinnumber: _this.searchCustomerPin.val(),
          CustomerCompany: _this.searchCustomerCompany.val(),
          CustomerCustom: _this.searchCustom.val()
        };


    if (hidden != true) {
      _this.resultTable.attr("disabled", "disabled");
      _this.resultTable.find("*").attr("disabled", "disabled");
      _this.resultTable.find("a").removeAttr("href");
      _this.chkListFilter_showAll.attr("disabled", "disabled");
      _this.btnSearch_submit.attr("disabled", "disabled");
      _this.btnDownloadResult.attr("disabled", "disabled");
      _this.btnExpand.attr("disabled", "disabled");
    }
    jQuery.ajaxSettings.traditional = true;
      $.ajax({
        url: "/Cashier/SearchOrders",
        type: 'POST',
        datatype: "json",
        data: searchParamsModel,
        traditional: true,
        error: function () {
          _this.searchResultList.html("");
          _this.searchResultList.html('<p>An error has occurred</p>');
          _this.searchResultList.fadeIn();
        },
        success: function (datan) {
          _this.data = datan;
          _this.searchResultList.html("");
          _this.resultTable.removeAttr("disabled");
          _this.resultTable.find("*").removeAttr("disabled");
          _this.chkListFilter_showAll.removeAttr("disabled");
          _this.btnSearch_submit.removeAttr("disabled");
          _this.btnDownloadResult.removeAttr("disabled");
          _this.btnExpand.removeAttr("disabled");

          if (datan.length > 50) {
            _this.cntSearchHits.html("+50")
          } else {
            _this.cntSearchHits.html(datan.length)
          }

          for (var i = 0; i < datan.length; i++) {

            var formattedDate = datan[i].orderDate.replace("T", " ").replace("Z", "").substring(0,16);
            var tr1 = document.createElement('tr');
            tr1.setAttribute("class", "btn btnShowOrder status_" + datan[i].orderStatus);
            tr1.setAttribute("data-id", datan[i].orderId);
            $(tr1).append("<td class=\"btn-filled link-btn-regular\">" + datan[i].orderId + "<span>" + datan[i].orderStatus + "</span></td>" +
              "<td>" + datan[i].customerId + "</td>" +
              "<td>" + datan[i].customerFirstName + " " + datan[i].customerLastName + "<span>" + datan[i].customerEmail + "</span></td>" +
              "<td>" + formattedDate + "</td>" +
              "<td>" + datan[i].orderAmount + " kr</td>" +
              "<td>" + datan[i].countOrderItems + "</td>");
            _this.searchResultList.append(tr1);

            var tr2 = document.createElement('tr');
            tr2.setAttribute("class", "orderview");
            tr2.setAttribute("data-id", datan[i].customerId);
            tr2.setAttribute("data-orderid", datan[i].orderId);
            $(tr2).append("<td colspan=9 class=\"orderview-data\"></td>");
              tr2.addEventListener("click", _this._editCustomer);
              tr2.addEventListener("click", _this._yabiePrint);
              tr2.addEventListener("click", _this._getReservationOrder);
            _this.searchResultList.append(tr2);
          }

          _this.searchResultList.fadeIn();


          var bodyRect = document.body.getBoundingClientRect();
          var elemRect = _this.searchResultList[0].getBoundingClientRect();
          var offset = elemRect.top - bodyRect.top;
          window.scrollTo({ top: offset - 120, behavior: 'smooth', });


          if (datan.length == 1) {
            _this.cntSearchHits.html(1);
            _this.searchResultList[0].firstChild.firstChild.click();
          }
        }
      });


  }

  _renderOrderView(order) {

    $.ajax({
      type: "POST",
      url: 'Cashier/OrderView',
      contentType: "application/json; charset=utf-8",
      data: { orderid: order.orderId },
      success: function (data) {
        return data;
      },
      error: function () { alert('A error'); }
    });

  }

  _formatPhone(mob, phone) {
    var result = "";
    if (mob != null && mob != "null") {
      result = mob;
    } else if (phone != null && phone != "null")
    {
      result = phone;
    }
    return result;
  }

  _btnShowOrder(e) {

    var id = $(e.target).parent().attr("data-id");
    var tdOrderView = $(e.target).parent().next("tr").find(".orderview-data")[0];

    if (e.target.localName == "span") {
      // Case when span in the td taking the click event
      id = $(e.target).parent().parent().attr("data-id");
      tdOrderView = $(e.target).parent().parent().next("tr").find(".orderview-data")[0];

    }

      if (tdOrderView.innerHTML == "") {
        tdOrderView.innerHTML == "Loading..."
          $.ajax({
              type: "POST",
              url: '/Cashier/OrderSearch_OrderView/',
              data: { orderId: id, IncludeRefunds: true },
              success: function (data) {
                  tdOrderView.innerHTML = data;
              },
              error: function () {
                  tdOrderView.innerHTML = "<h2>Error</h2>";
              }
          });
      }

    if (e.target.localName == "span") {
      $(e.target).parent().parent().toggleClass("open");
      $(e.target).parent().parent().next("tr").toggleClass("open");
    } else {
      $(e.target).parent().toggleClass("open");
      $(e.target).parent().next("tr").toggleClass("open");
    }
  }

    _yabiePrint(e) {
        if (e.target.id == "btnYabiePrint") {
            var orderId = e.currentTarget.dataset.orderid;
            var $row = $('tr[data-orderid="' + orderId + '"]');
            var $orderItemTable = $row.find(".orderitem-table");
            var pickedOrderItems = [];
            $('input[type="checkbox"]:checked', $orderItemTable).each(function () {

                pickedOrderItems.push(this.attributes.id.value);
            });

            $.ajax({
                type: "POST",
                url: '/Cashier/GetYabiePrintUrl/',
                data: { orderId: orderId, orderItemIds: pickedOrderItems },
                success: function (data) {
                    $("#hiddenPrintAnchor").attr("href", data);
                    document.getElementById("hiddenPrintAnchor").click();
                },
                error: function () {
                    alert('A error');
                }
            });

            // Prevent the page from scrolling to the top.
            e.preventDefault();
        }
    }

    _disableOrderbuttons(e) {
        if (e.target.type == "checkbox") {
            var orderId = e.currentTarget.dataset.orderid;
            var $row = $('tr[data-orderid="' + orderId + '"]');
            var $orderItemTable = $row.find(".orderitem-table");
            var allCheckboxes = 0;
            var checkedCheckboxes = 0;

            //Buttons
            var btnDiv = $row.find(".btnRow");

            var refundButton = btnDiv.find("#refundButton");
            var editCustomerButton = btnDiv.find("#btnEditCustomer");
            var reservationButton = btnDiv.find("#reservationButton");

            $('input[type="checkbox"]', $orderItemTable).each(function () {
                allCheckboxes++;
                if (this.checked) {
                    checkedCheckboxes++;
                }
            });

            if (checkedCheckboxes >= 1 && checkedCheckboxes < allCheckboxes) {

                refundButton.attr('disabled', 'disabled');
                editCustomerButton.attr('disabled', 'disabled');
                reservationButton.attr('disabled', 'disabled');
            }
            else {
                refundButton.removeAttr('disabled');
                editCustomerButton.removeAttr('disabled');
                reservationButton.removeAttr('disabled');
            }
        }
    }

    _getReservationOrder(e) {
        if (e.target.id == "reservationButton") {
            var orderId = e.currentTarget.dataset.orderid;
            var $row = $('tr[data-orderid="' + orderId + '"]');
            var $orderItemTable = $row.find(".orderitem-table");
            var pickedOrderItems = [];
            $('input[type="checkbox"]:checked', $orderItemTable).each(function () {

                pickedOrderItems.push(this.attributes.id.value);
            });

            $.ajax({
                type: "POST",
                url: 'Cashier/GetReservationOrder/',
                data: { orderId: orderId, orderItemIds: pickedOrderItems },
                success: function (data) {
                    window.location.href = 'Cart';
                    return data;
                },
                error: function () {
                    alert('A error');
                }
            });

            // Prevent the page from scrolling to the top.
            e.preventDefault();
        }
    }

    _editCustomer(e) {
    if (e.target.id == "btnEditCustomer") {
      const edit_id = e.currentTarget.dataset.id;
      const edit_orderid = e.currentTarget.dataset.orderid;
        this.modalTitle[0].innerText = "Redigera kund: " + edit_id;
        this.customerUpdateOnOrder.checked = true;
        this.customerupdateAllOrders.checked = false;
        this.btnModalMsg.hide();
        this.btnModalMsgSuccess.hide();
        this.btnModalLoading.hide();

      let _this = this;
      $.ajax({
        url: "/Cashier/GetCustomer",
        type: 'POST',
        data: jQuery.param({ customerId: edit_id }),
          error: function () {
          _this.btnModalMsg.fadeIn();
          _this.modalAddCustomer.show();
        },
        success: function (data) {
          if (data.id > 0) {
            _this.editCustomerId = edit_id;
            _this.customerFirstname.val(data.firstName);
            _this.customerLastname.val(data.lastName);
            _this.customerEmail.val(data.email);
            _this.customerPhone.val(data.phone);
            _this.customerAddress.val(data.address);
            _this.customerAddress2.val(data.address2);
            _this.customerZipCode.val(data.postcode);
            _this.customerCity.val(data.city);
            _this.customerCountry.val(data.country);
            _this.customerPhone2.val(data.mobile);
            _this.customerOrderId.val(edit_orderid);

            _this.modalAddCustomer.show();
          } else {
            _this.btnModalMsg.fadeIn();
            _this.modalAddCustomer.show();
          }
        }
      });
      e.preventDefault();
    }
  }

  _btnCustomerModalEditSubmit() {

    var orderidtoUpdate = 0;
    if (this.customerUpdateOnOrder.prop('checked')) {
      orderidtoUpdate= this.customerOrderId.val()
    }
    var updateAllCustomerOrders = false;
    if (this.customerupdateAllOrders != null && this.customerupdateAllOrders.prop('checked')) {
        updateAllCustomerOrders = true;
    }


    var _this = this;
    var data = jQuery.param({
      customerModel: {
        Id: _this.editCustomerId,
        FirstName: _this.customerFirstname.val(),
        LastName: _this.customerLastname.val(),
        Email: _this.customerEmail.val(),
        Phone: _this.customerPhone.val(),
        Address: _this.customerAddress.val(),
        Address2: _this.customerAddress2.val(),
        PostCode: _this.customerZipCode.val(),
        City: _this.customerCity.val(),
        Country: _this.customerCountry.val(),
        Mobile: _this.customerPhone2.val()
        },
        orderToUpdate: orderidtoUpdate,
        updateAllCustomerOrders: updateAllCustomerOrders
    });

      _this.customerEditResponseMessageDiv.fadeIn();
      var blink = setInterval(function () {
          _this.btnModalLoading.fadeTo(200, 0.1).fadeTo(400, 1.0);
      }, 1000)
    $.ajax({
      url: "/Cashier/UpdateCustomer",
      type: 'POST',
      data: data,
        error: function () {
           clearInterval(blink);
          _this.btnModalLoading.hide();
          _this.btnModalMsg.fadeIn();
      },
        success: function (data) {
             clearInterval(blink);
            _this.btnModalLoading.hide();
          if (data.status == "OK") {
              _this.btnModalMsgSuccess.show();
             // Sätt kunddata i lista och sök
              $(_this.searchCustomerNr).val(data.customerId);
              _this._searchSubmit();
              _this.modalAddCustomer.fadeIn().delay(3000).fadeOut();
             _this.editCustomerId = 0;
        } else {
          if (data.status == "ERROR_MAIL_NOT_FREE") {
            _this.btnModalMsg.fadeIn();
          } else {
            _this.btnModalMsg.fadeIn();
          }
        }
      }
    });
  }

  // CANCEL //
  _btnCustomerModalCancel() {
    this.editCustomerId = 0;
    this.modalAddCustomer.hide();
  }
}